import { SUPPORTED_ENVIRONMENT, settings } from '@/_config/constants';

const envs = [SUPPORTED_ENVIRONMENT.PRODUCTION];

let ga4Initialized = false;

declare global {
  interface Window {
    ga4EventsPipe: unknown[];
    ga4Timer: string | number | NodeJS.Timeout | null | undefined;
  }
}

window.ga4EventsPipe = [];
window.ga4Timer = null;

const init = () => {
  import('react-ga4').then((GA4) => {
    const ReactGA = GA4.default;
    if (!envs.includes(settings.currentEnvironment)) {
      return undefined;
    }
    let code = 'G-WGTTVTQXW2';
    if (settings.isATP) {
      code = 'G-WTG1KV0L1S';
    } else if (settings.isUnified) {
      code = 'G-CCRXD4GQ15';
    }

    if (!ga4Initialized) {
      ReactGA.initialize(code, {
        testMode: !envs.includes(settings.currentEnvironment),
      });
      ga4Initialized = true;
    }

    return undefined;
  });
};

const event = (evtData: unknown) => {
  window.ga4EventsPipe.push(evtData);
  if (!ga4Initialized) return;

  import('react-ga4').then((GA4) => {
    const ReactGA = GA4.default;
    if (!envs.includes(settings.currentEnvironment)) return undefined;

    if (!window.ga4Timer) {
      window.ga4Timer = setInterval(() => {
        if (window.ga4EventsPipe.length > 0) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ReactGA.event(window.ga4EventsPipe.shift() as unknown);
        } else {
          clearInterval(window.ga4Timer as number);
          window.ga4Timer = null;
        }
      }, 2000);
    }
    return undefined;
  });
};

const googleAnalytics4 = {
  init,
  event,
};

export default googleAnalytics4;
